import { Button, Card, List, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

const SelectedKeywords = (props) => {
  // props.startTime (required)
  // props.endTime (required)
  // const [keywordsData, setKeywordsData] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(true);
  const teamId = localStorage.getItem("team-id");
  const supaClient = getSupaClient();

  const loadKeywords = async () => {
    const localKeywords = localStorage.getItem("dots-keywords");

    // check local first
    if (localKeywords) {
      // setKeywords(JSON.parse(localKeywords));
      return { data: JSON.parse(localKeywords) };
    }
    // otherwise grab it from backedn

    const { data, error } = await supaClient
      .from("keywords_tracker")
      .select("keyword")
      .filter("team", "eq", teamId);

    if (error) {
      console.log("error in keywords", error);
      return { error: "Error" };
    }
    // setKeywords(data);
    localStorage.setItem("dots-keywords", JSON.stringify(data));
    return { data };
  };

  // search for a specific keyword and return a sum of total_count
  const searchKeywordCount = async (keyword) => {
    const params = {
      start_time: props.startTime,
      end_time: props.endTime,
      team_id: teamId,
      keyword,
    };
    const { data, error } = await supaClient.rpc("keyword_counts", params);

    if (error) console.log("error in search Keyword", error);
    else {
      // console.log("got keywordsData", data);
      const count = data.reduce((total, obj) => obj.total_count + total, 0);
      return count;
    }
    return 0;
  };

  const loadData = async () => {
    const keywordsList = await loadKeywords();

    if (keywordsList.error) {
      console.log("eror in getting keywords");
    } else {
      const formattedKeywords = keywordsList.data.map(async (item) => {
        const count = await searchKeywordCount(item.keyword);
        return { keyword: item.keyword, count };
      });
      // wait for the promise to resolve
      Promise.all(formattedKeywords).then((values) => {
        setKeywords(values);
        setLoading(false);
      });
    }
  };

  // search when time changes
  useEffect(async () => {
    setLoading(true);
    await loadData();
  }, [props.startTime, props.endTime]);

  // load first time
  useEffect(async () => {
    setLoading(true);
    await loadData();
  }, []);

  return (
    <Card title="Selected keyword tracker" bordered={false}>
      <Spin spinning={loading}>
        <div style={{ width: "100%", height: "250px", paddingBottom: 10 }}>
          {keywords.length === 0 ? (
            <p>Please contact support to add keywords!</p>
          ) : (
            <List
              size="small"
              bordered
              dataSource={keywords}
              renderItem={(item) => (
                <List.Item actions={[<p>{item.count} Mentions</p>]}>
                  {item.keyword}
                </List.Item>
              )}
            />
          )}
        </div>
      </Spin>
    </Card>
  );
};

export default SelectedKeywords;
